import Vue from "vue";
import vMediaQuery from "v-media-query";

Vue.use(vMediaQuery);



// WEBPACK FOOTER //
// ./src/media-queries.js